import { render, staticRenderFns } from "./returnSearch.vue?vue&type=template&id=61db9892&scoped=true&"
import script from "./returnSearch.vue?vue&type=script&lang=ts&"
export * from "./returnSearch.vue?vue&type=script&lang=ts&"
import style0 from "./returnSearch.vue?vue&type=style&index=0&id=61db9892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db9892",
  null
  
)

export default component.exports